import { useState } from 'react';
import { DEFAULT_PRESETS, PRESETS_STORAGE_KEY } from '../shared/constants.js';
import { useLocalStorageState } from '../shared/db.js';
import { useLanguage } from '../context/LanguageContext.js';
import { usei18n } from '../i18n/i18n.js';
import { toTimeLocalValue, withUpdatedTime, isSameDay } from '../shared/utilities.js';
import DoseSelector from './DoseSelector.js';
import RoundModal from './RoundModal.js';
import './EditDoseModal.css';

const EditDoseModal = ({ dose, previousTimestamp, onSave, onClose }) => {
    const [size, selectDose] = useState(dose.size);
    const [when, setWhen] = useState(toTimeLocalValue(dose.timestamp));
    const [presets] = useLocalStorageState(PRESETS_STORAGE_KEY, DEFAULT_PRESETS);
    const { language } = useLanguage();
    const i18n = usei18n(language);

    const originalTime = toTimeLocalValue(dose.timestamp);
    const minTime = previousTimestamp && isSameDay(previousTimestamp, dose.timestamp) ? toTimeLocalValue(previousTimestamp) : undefined;
    const maxTime = isSameDay(dose.timestamp, new Date()) ? toTimeLocalValue(new Date()) : undefined;

    const clampTime = (value) => {
        if (minTime && value < minTime) return minTime;
        if (maxTime && value > maxTime) return maxTime;
        return value;
    };

    const handleSave = () => {
        const time = clampTime(when);
        if (time === originalTime) {
            onSave({ ...dose, size });
            return;
        }
        let timestamp = withUpdatedTime(dose.timestamp, time);
        // Same minute as the previous dose: keep it strictly after so ordering and keys stay unique.
        if (previousTimestamp && new Date(timestamp) <= new Date(previousTimestamp)) {
            timestamp = new Date(new Date(previousTimestamp).getTime() + 1000).toISOString();
        }
        onSave({ ...dose, timestamp, size });
    };

    return (
        <RoundModal onClose={onClose} onBackdropClick={onClose} id="edit-dose-modal-panel">
            <div className="edit-dose-modal">
                {dose.letter ? null : <DoseSelector presets={presets} selected={size} selectDose={selectDose} />}
                <input
                    type="time"
                    className="edit-timestamp"
                    value={when}
                    onChange={(e) => e.target.value && setWhen(clampTime(e.target.value))}
                    min={minTime}
                    max={maxTime}
                />
                <button
                    type="button"
                    className="confirm-dose"
                    onClick={handleSave}
                    aria-label={i18n('modal.editDose.save')}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M4 12l5 5L20 6" />
                    </svg>
                </button>
            </div>
        </RoundModal>
    )
}

export default EditDoseModal;
